import { render, staticRenderFns } from "./Partenaire.vue?vue&type=template&id=40b5acae&"
import script from "./Partenaire.vue?vue&type=script&lang=js&"
export * from "./Partenaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Partenaire.vue"
export default component.exports